import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Spin } from 'antd';
import GafaFormaSvg from '../../assets/img/gafa_forma.svg';
import { obtenerImagenesArticulosRequest } from '../../../../state/actions/creators/articulos.actioncreator';
import { Box } from '../../../shared/components';

class ArticuloImagenLoader extends React.Component {

  componentDidMount() {
    const { articulo, imagenObj } = this.props;
    if (imagenObj === undefined) {
      const { obtenerImagenesArticulosRequest } = this.props;
      if (articulo) {
        obtenerImagenesArticulosRequest({ articulos: [articulo] });
      }
    }
  }

  render() {
    const { articulo } = this.props;
    if (articulo === null || articulo === undefined) return null;

    const { imagenObj } = this.props;
    const loading = (imagenObj) ? imagenObj.loading : true;

    let imgSrc = GafaFormaSvg;
    if (imagenObj && imagenObj.src) {
      imgSrc = imagenObj.src;
    }

    return (
      <Box>
        { loading === true ? <Spin /> : <img style={{ padding: (imgSrc == GafaFormaSvg) ? '8px' : '0px'}} src={imgSrc} alt="Logo" width="100%" /> }
      </Box>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { articulos: { imagenes } } = state;
  const { articulo } = ownProps;

  if (articulo === null || articulo === undefined) {
    return {};
  }
  const { codigo } = articulo;
  return {
    imagenObj: imagenes[codigo],
  };
};


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    obtenerImagenesArticulosRequest,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArticuloImagenLoader);
